export { TABS } from './Sidebar.component';
export { default } from './Sidebar.container';
